import Flickity from './Flickity';

const sliderConfig = {
  arrowShape: 'M24.5,51.6v-3.2l19.6-19.6l3.2,3.2L31.5,47.8h44.1v4.5H31.5L47.2,68l-3.2,3.2L24.5,51.6z',
  wrapAround: true,
  adaptiveHeight: true,
};

export default class HomeEvents {
  constructor(element) {
    this.element = element;

    // Exit if we don't have more than one slide.
    if (!this.shouldBuildSlider) return;

    // Build Slider
    this.buildSlider();
  }

  buildSlider() {
    this.slider = new Flickity(this.sliderElement, sliderConfig);
  }

  get shouldBuildSlider() {
    return this.slides.length > 1;
  }

  get sliderElement() {
    return this.element.querySelector('.view-content');
  }

  get slides() {
    return this.sliderElement.childNodes;
  }
}
